import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { TranslateService } from "@ngx-translate/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Storage } from "@ionic/storage";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  LoadingController,
  NavParams,
} from "ionic-angular";
import { GoogleChartInterface } from "ng2-google-charts/google-charts-interfaces";
import { VideoTutorialModalPage } from "../video-tutorial-modal/video-tutorial-modal";
// import {
//   StreamingMedia,
//   StreamingVideoOptions,
// } from "@ionic-native/streaming-media";

@IonicPage()
@Component({
  selector: "page-shopper-result",
  templateUrl: "shopper-result.html",
})
export class ShopperResultPage {
  round = 1;
  public loadProgress: number = 0;
  items: any;
  purchaseds: any;
  target_hp = 0;
  received_hp = 0;
  shop = 0;
  social = 0;
  theme = 0;
  lang = "";
  themes = 1;

  // public dataTable = [
  //   ["SHOP", this.shop],
  //   ["SOCIAL", this.social],
  //   ["THEME", this.theme],
  // ];

  public pieChart: GoogleChartInterface = {
    chartType: "PieChart",
    dataTable: this.navParams.data.stat_hp,
    opt_firstRowIsData: true,
    options: {
      title: "",
      pieSliceText: "value",
      legend: {
        position: "none",
        //  textStyle: {color: '#d59237', fontSize: 14},
        //  alignment: 'center',
        //  maxLines: 1
      },
      is3D: false,
      chartArea: {
        left: 0,
        top: 5,
        bottom: 5,
        width: "100%",
        height: "100%",
        strokeWidth: 1,
        stroke: "#f3a141",
      },
      // width: '100%',
      backgroundColor: { fill: "transparent" },
      colors: ["#eb6736", "#d6a23a", "#479e48"],
      animation: {
        duration: 1000,
      },
    },
  };

  stat_hp: any;
  change_plaze = 0;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    public translateService: TranslateService,
    private loadingCtrl: LoadingController,
    public navParams: NavParams // private streamingMedia: StreamingMedia
  ) {
    // this.stat_hp = this.navParams.data.stat_hp;
  }

  async ionViewDidLoad() {
    this.themes = await this.storage.get("theme");

    this.storage.get("roundGame").then((round) => {
      this.storage.get("language").then((lang) => {
        this.lang = lang;
        this.round = round;
      });
    });

    // this.pieChart.dataTable = this.stat_hp;
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLShopperStatItems;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.items = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      var link2 = this.services.URLShopperStatPurchased;
      this.http
        .get(link2, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.purchaseds = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      var link3 = this.services.URLShopperStatHappiness;
      this.http
        .get(link3, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.loadProgress = Math.floor(data.percent);
            this.target_hp = data.target_hp;
            this.received_hp = data.received_hp;

            this.shop = parseInt(data.shop);
            this.social = parseInt(data.social);
            this.theme = parseInt(data.theme);
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      var link4 = this.services.URLShopperBag;
      this.http
        .get(link4, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.change_plaze = data.change_plaze;
          },
          (error) => {
            var response = JSON.parse(error._body);
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });

    loader.dismiss();
  }

  backPage() {
    this.navCtrl.push(ShopperHomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.push(ShopperHomePage);
  }

  showVideo() {
    // let options: StreamingVideoOptions = {
    //   successCallback: () => {
    //     console.log("Video played");
    //   },
    //   errorCallback: (e) => {
    //     console.log("Error streaming");
    //   },
    //   orientation: "landscape",
    //   shouldAutoClose: true,
    //   controls: true,
    // };

    if (this.lang == "en-Us") {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 16,
          vdo: video[16].video_url,
        });
        // this.streamingMedia.playVideo(video[16].video_url, options);
      });
    } else {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 17,
          vdo: video[17].video_url,
        });
        // this.streamingMedia.playVideo(video[17].video_url, options);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-result/shopper-result.ts